export const en = {
    newsEnd: 'There is no more news...',
    quickLinks: 'Quick Links',
    contacts: 'Contacts',
    socialMedias: 'Social medias',
    mainNews: 'Main news',
    rubrics: 'Rubrics',
    siteCreatedBy: 'Site created by: ',
    projectTarget: 'Purpose of the project:',
    targetText: 'Introduction of adolescents and young people with special abilities into society, promotion and stimulation of their intellectual activity in the modern era of rapid development of new technologies.',
    companyText: 'The site was developed with the financial assistance of The Council of State Support to Non-Governmental Organizations under the President of the Republic of Azerbaijan. Opinions and opinions reflected on the website belong to the author and do not reflect the official position of The Council of State Support to Non-Governmental Organizations under the President of the Republic of Azerbaijan.',
	chevik: 'Chevik.az project © All rights reserved'
}